'use client';
import { useRouter } from 'next/navigation';
import Link from 'next/link'
import Image from 'next/image';
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { usePathname } from 'next/navigation'
import { isLoggedIn, fetchNewJobsToday } from '@/app/funcs/api'
import './navbar.css'; // Import the CSS file for styling
import '../breadcrumbs/breadcrumbs.css';
import chatGTP from './../../assets/images/ChatGPT-Logo.svg'
import { truncateText } from '@/app/funcs/funcs'
import BreadcrumbsNav from '../breadcrumbs/Breadcrumbs'
// import GoogleOneTap from '../auth/GoogleOneTap';
import { GoogleOAuthProvider, useGoogleOneTapLogin } from '@react-oauth/google';


// Notification dot component
const NotificationDot = ({ count }) => {
    if (count === 0) return null;

    return (
        <span className="notification-dot badge bg-danger">
            {count > 99 ? '99+' : count}
        </span>
    );
};


const OneTap = () => {
    useGoogleOneTapLogin({
        onSuccess: credentialResponse => {
            console.log(credentialResponse);
        },
        onError: () => {
            console.log('Login Failed');
        },
    });
}





export default function Navbar() {

    const [authi, setAuthi] = useState(false);
    const [user, setUser] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isNavbarVisible, setIsNavbarVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [isDark, setIsDark] = useState(false);
    const [todayJobsCount, setTodayJobsCount] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchModal, setShowSearchModal] = useState(false);

    const pathname = usePathname()
    const router = useRouter();
    const navItems = [
        // { label: 'الرئيسية', href: '/', icon: 'bi bi-house' },
        // { label: 'عن فيجماوية', href: '/about', icon: 'bi bi-info-circle' },
        // { label: 'الاختبارات', href: '/services/quizzes', icon: 'bi bi-clipboard-check' },
        { label: 'الدورات التعليمية', href: '/courses', icon: 'bi bi-mortarboard' },
        { label: 'الإختبارات', href: '/quizzes', icon: 'bi bi-clipboard-check' },
        // { label: 'الاستبيانات', href: '/surveys', icon: 'bi bi-ui-checks' },
        { label: 'التحديات', href: '/challenges', icon: 'bi bi-trophy' },
        { label: 'تسعير', href: '/calc', icon: 'bi bi-calculator' },
        { label: 'إسمعنا', href: '/podcasts', icon: 'bi bi-headphones' },
        // { label: 'رمضان', href: '/ramadan', icon: 'bi bi-moon-fill' },
        { label: 'المقالات', href: '/articles', icon: 'bi bi-pencil' },
        // { label: 'إختصار الروابط', href: '/lnk', icon: 'bi bi-scissors' },
        { label: 'القاموس', href: '/glossary', icon: 'bi bi-book' },

        // { label: 'قوالب', href: '/sections/templates' },
        // { label: 'إضافات', href: '/sections/plugins' },
        // { label: 'الوظائف', href: '/sections/jobs', icon: 'bi bi-briefcase', showNotification: true },
        // { label: 'دليل المصممين', href: '/pages/hire', icon: 'bi bi-people-fill' },
        // { label: 'الشهادات', href: '/cert', icon: 'bi bi-award' },
        // { label: 'الجلسات', href: '/sessions', icon: 'bi bi-play-btn' },

        // { label: 'ذكي AI', href: 'https://chatgpt.com/g/g-6827324583b48191a6713f1ec6b89bae-dhky-mn-fyjmwy-zaki-by-figmawya', new: true, icon: 'bi bi-robot' },
        // { label: 'تواصل معنا', href: '/contact', icon: 'bi bi-envelope' },
    ]

    // Fetch today's jobs count
    const fetchTodayJobs = useCallback(async () => {
        try {
            const { count } = await fetchNewJobsToday();
            setTodayJobsCount(count);
        } catch (error) {
            // Set a fallback count for testing purposes
            setTodayJobsCount(0); // This will show a notification dot for testing
        }
    }, []);

    useEffect(() => {
        // Fetch today's jobs count
        fetchTodayJobs();
        // Set up interval to check for new jobs every 30 minutes
        const interval = setInterval(fetchTodayJobs, 30 * 60 * 1000);
        return () => clearInterval(interval);
    }, [fetchTodayJobs]);


    // Initialize theme state from localStorage / body class
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const storedTheme = localStorage.getItem('theme');
        const hasDarkClass = document.body.classList.contains('dark');
        if (storedTheme === 'dark' || hasDarkClass) {
            document.body.classList.add('dark');
            setIsDark(true);
        } else {
            document.body.classList.remove('dark');
            setIsDark(false);
        }
    }, []);

    const toggleTheme = () => {
        if (typeof window === 'undefined') return;
        // Disable auto switching when user toggles manually
        localStorage.setItem('theme-auto-switch', '0');
        if (isDark) {
            document.body.classList.remove('dark');
            localStorage.setItem('theme', 'light');
            setIsDark(false);
        } else {
            document.body.classList.add('dark');
            localStorage.setItem('theme', 'dark');
            setIsDark(true);
        }
    };

    // Fetch today's jobs count
    const fetchAuth = useCallback(async () => {
        try {
            let islogged = await isLoggedIn();
            setAuthi(islogged);
            console.log(islogged);

        } catch (error) {
            // Set a fallback count for testing purposes
            console.log('Authi Error');
        }
    }, []);

    useEffect(() => {
        fetchAuth();
    }, [authi])

    useEffect(() => {
        authi == true ? setUser(JSON.parse(localStorage.getItem('user'))) : '';
        // console.log(authi ? JSON.parse(localStorage.getItem('user')) : 'not logged in');
    }, [authi])

    // Scroll detection for mobile navbar hide/show
    useEffect(() => {
        let ticking = false;
        let scrollTimeout;

        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    const currentScrollY = window.scrollY;

                    // Only apply scroll behavior on mobile (width < 992px)
                    if (window.innerWidth < 992) {
                        // Always show navbar when menu is open
                        if (isMenuOpen) {
                            setIsNavbarVisible(true);
                        } else {
                            // Show navbar at the top of the page
                            if (currentScrollY < 50) {
                                setIsNavbarVisible(true);
                            } else {
                                // Hide navbar when scrolling down, show when scrolling up
                                const isScrollingDown = currentScrollY > lastScrollY && currentScrollY > 50;
                                const isScrollingUp = currentScrollY < lastScrollY;

                                if (isScrollingDown && isNavbarVisible) {
                                    setIsNavbarVisible(false);
                                } else if (isScrollingUp && !isNavbarVisible) {
                                    setIsNavbarVisible(true);
                                }
                            }
                        }
                    } else {
                        // Always show navbar on desktop
                        setIsNavbarVisible(true);
                    }

                    setLastScrollY(currentScrollY);
                    ticking = false;
                });
                ticking = true;
            }
        };

        // Debounced scroll handler for better performance
        const debouncedScrollHandler = () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(handleScroll, 5);
        };

        window.addEventListener('scroll', debouncedScrollHandler, { passive: true });

        return () => {
            window.removeEventListener('scroll', debouncedScrollHandler);
            clearTimeout(scrollTimeout);
        };
    }, [lastScrollY, isNavbarVisible, isMenuOpen]);

    const closeMenu = () => {
        const nav = document.getElementById("navbarNavAltMarkup");
        if (nav && window.innerWidth < 992) { // Check if on mobile
            const bsCollapse = bootstrap.Collapse.getInstance(nav) || new bootstrap.Collapse(nav, { toggle: false });
            bsCollapse.hide(); // Close the menu
        }
        setIsMenuOpen(false);
    }

    // Handle burger menu toggle
    const handleBurgerMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
        // Ensure navbar is visible when menu is being opened
        if (!isMenuOpen) {
            setIsNavbarVisible(true);
        }
    };

    // Listen for Bootstrap collapse events to sync state
    useEffect(() => {
        const navbar = document.getElementById("navbarNavAltMarkup");
        if (navbar) {
            const handleShow = () => setIsMenuOpen(true);
            const handleHide = () => setIsMenuOpen(false);

            navbar.addEventListener('show.bs.collapse', handleShow);
            navbar.addEventListener('hide.bs.collapse', handleHide);

            return () => {
                navbar.removeEventListener('show.bs.collapse', handleShow);
                navbar.removeEventListener('hide.bs.collapse', handleHide);
            };
        }
    }, []);

    // Reset menu state when window is resized to desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                setIsMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Remove blur effect from main content
    const removeBlur = () => {
        const mainElement = document.querySelector('.mainContent');
        if (mainElement) {
            mainElement.classList.remove('main-blur');
        }
    };

    // Handle navigation to different account sections
    const handleAccountNavigation = useCallback((section) => {
        try {
            const currentUrl = new URL(window.location.href);
            if (section) {
                currentUrl.searchParams.set('section', section);
            } else {
                currentUrl.searchParams.delete('section');
            }
            router.push(`/account${section ? `?section=${section}` : ''}`);
        } catch (error) {
            console.error('Navigation error:', error);
            // Fallback navigation
            router.push(`/account${section ? `?section=${section}` : ''}`);
        }
    }, [router]);

    // Toggle blur effect on main content when dropdown is clicked
    useEffect(() => {
        const handleDropdownToggle = () => {
            const mainElement = document.querySelector('.mainContent');
            if (mainElement) {
                mainElement.classList.toggle('main-blur');
            } else {
            }
        };

        // Function to add event listeners
        const addEventListeners = () => {
            const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

            dropdownToggles.forEach(toggle => {
                // Remove existing listener to prevent duplicates
                toggle.removeEventListener('click', handleDropdownToggle);
                // Add new listener
                toggle.addEventListener('click', handleDropdownToggle);
            });
        };

        // Try multiple times to ensure DOM is ready
        addEventListeners();
        setTimeout(addEventListeners, 100);
        setTimeout(addEventListeners, 500);
        setTimeout(addEventListeners, 1000);

        // Also listen for DOM changes
        const observer = new MutationObserver(() => {
            addEventListeners();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Cleanup function
        return () => {
            const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
            dropdownToggles.forEach(toggle => {
                toggle.removeEventListener('click', handleDropdownToggle);
            });
            observer.disconnect();
        };
    }, []);

    const handleLogout = () => {
        sessionStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        router.push('/login');
        setAuthi(false);
    };

    const searchInputRef = useRef(null);

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            router.push(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
            setSearchQuery('');
            setShowSearchModal(false);
            closeMenu();
        }
    };

    const handleSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch(e);
        }
    };

    const openSearchModal = () => {
        setShowSearchModal(true);
    };

    const closeSearchModal = () => {
        setShowSearchModal(false);
        setSearchQuery('');
    };

    // Auto-focus search input when modal opens
    useEffect(() => {
        if (showSearchModal && searchInputRef.current) {
            setTimeout(() => {
                searchInputRef.current?.focus();
            }, 100);
        }
    }, [showSearchModal]);

    return (
        <>
            {/* <GoogleOneTap /> */}
            {/* <GoogleOAuthProvider clientId="972759779991-rtjp4vb13bosiv282b7nmc8tas99okae.apps.googleusercontent.com">
                <OneTap />
            </GoogleOAuthProvider> */}
            <nav
                id="header"
                className={`navbar navbar-expand-lg navbar-light py-1 py-md-3 mx-2 mx-md-auto fixed-top bg-blur container-md-fluid container-xl ${isNavbarVisible ? 'navbar-scroll-visible' : 'navbar-scroll-hidden'
                    }`}
            >
                <div className="container-fluid justify-content-start justify-content-md-between align-items-center">
                    <button
                        id='burgerMenu'
                        className="navbar-toggler me-2 border-0"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNavAltMarkup"
                        aria-controls="navbarNavAltMarkup"
                        aria-expanded={isMenuOpen}
                        aria-label="Toggle navigation"
                        onClick={handleBurgerMenuToggle}
                    >
                        {isMenuOpen ? (
                            <i className="bi bi-x-lg fs-1"></i>
                        ) : (
                            <i className="bi bi-list-nested fs-1"></i>
                        )}
                    </button>

                    <Link href="/" onClick={closeMenu} className='navbar-brand d-flex col-auto col-md-2 logoLink mx-auto ms-md-5 ps-md-0 ms-xl-2'> <img src='/logo.svg' alt="logo" width={48} height={48} /> <span className='ms-2'>
                        <b className='d-none d-md-block text-dark'>فيجماوية</b>
                        <span className='d-none d-md-block text-dark blink py-0 px-1 w-fit rounded-2'>تجريبي</span>
                    </span> </Link>

                    {/* Search Icon Button - Desktop */}


                    {/* <span className='d-block d-md-none'><i className='bi bi-person-circle'></i></span> */}

                    {/* <button
                                className="btn btn-outline-dark rounded-3 d-md-block d-none me-1 py-1 px-2 w-auto"
                                aria-label="البحث"
                                onClick={openSearchModal}
                                title="البحث"
                            >
                                <i className="bi bi-search fs-5 text-dark"></i>
                            </button> */}
                    {/* Mobile theme toggle */}


                    {/* Temporary test button for notifications */}
                    {/* <button 
                    className="btn btn-outline-danger rounded-3 d-none d-inline-flex me-2 w-auto"
                    onClick={() => setTodayJobsCount(prev => prev + 1)}
                    title="Test notification"
                >
                    <i className="bi bi-bell fs-5"></i>
                </button> */}

                    {authi === true ? (
                        <div className="ms-md-auto col-md-8 ms-md-4 ms-xl-5 align-items-center my-4 my-md-0 d-inline-flex d-md-none">
                            <button
                                className="btn btn-outline-dark rounded-3 d-md-block d-none me-1 py-1 px-2 w-auto"
                                aria-label="البحث"
                                onClick={openSearchModal}
                                title="البحث"
                            >
                                <i className="bi bi-search fs-5 text-dark"></i>
                            </button>
                            <button
                                className="d-none d-md-block btn btn-outline-dark rounded-3 d-md-none me-1 py-1 px-2 w-auto fs-5"
                                aria-label={isDark ? 'Light mode' : 'Dark mode'}
                                onClick={toggleTheme}
                            >
                                <i className={`bi ${isDark ? 'bi-sun' : 'bi-moon'} fs-5 text-dark`}></i>
                            </button>

                            <div className="dropdown">
                                <button
                                    className="btn btn-outline-dark dropdown-toggle rounded-3 px-2"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    onClick={() => {
                                        const mainElement = document.querySelector('.mainContent');
                                        if (mainElement) {
                                            mainElement.classList.toggle('main-blur');
                                        }
                                    }}
                                >

                                    {/* { JSON.stringify(user)} */}

                                    {user && user.avatar ? (<Image src={user.avatar} className='rounded-circle' width={24} height={24} />) : <i className='bi bi-person-circle'></i>}
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end">
                                    {/* <li>
                                        <button
                                            className="dropdown-item"
                                            aria-label={isDark ? 'Light mode' : 'Dark mode'}
                                            onClick={toggleTheme}>
                                            <i className={`bi ${isDark ? 'bi-sun' : 'bi-moon'} fs-6 text-dark`}></i> <span>{isDark ? 'النمط النهاري' : 'النمط الليلي'}</span>
                                        </button>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li> */}
                                    {/* <li><a href={`https://figmawya.com/@${user?.user_nicename ? user?.user_nicename : user?.username}`} rel="noopener noreferrer" className='py-2 px-3'><i className='bi bi-person-circle me-2'></i> حسابي</a></li> */}
                                    {/* <li><h6 className="dropdown-header">مرحباً : <b>{user?.name}</b> 👋</h6></li> */}
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => { handleAccountNavigation('accountSettings'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-gear me-2'></i>إعدادات الحساب
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => { handleAccountNavigation('security'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-lock me-2'></i>الأمان وكلمة المرور
                                        </button>
                                    </li>
                                    {/* <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => { handleAccountNavigation('myLinks'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-link-45deg me-2'></i>الروابط المختصرة
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item opacity-50"
                                            onClick={() => { handleAccountNavigation('challenges'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-trophy me-2'></i>التحديات اليومية
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item opacity-50"
                                            onClick={() => { handleAccountNavigation('achievements'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-award me-2'></i>الشهادات والإنجازات
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item opacity-50"
                                            onClick={() => { handleAccountNavigation('workSamples'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-brush me-2'></i>نماذج أعمالي
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item opacity-50"
                                            onClick={() => { handleAccountNavigation('favorites'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-bookmark-heart me-2'></i>المفضلة والمحفوظات
                                        </button>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><h6 className="dropdown-header"><i className='bi bi-collection me-2'></i>إدارة المحتوى</h6></li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => { handleAccountNavigation('templates'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-file-earmark-text me-2'></i>القوالب
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => { handleAccountNavigation('plugins'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-puzzle me-2'></i>الإضافات
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => { handleAccountNavigation('articles'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-journal-text me-2'></i>المقالات
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => { handleAccountNavigation('jobs'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-briefcase me-2'></i>الوظائف
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item opacity-50"
                                            onClick={() => { handleAccountNavigation('projects'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-folder me-2'></i>المشاريع
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item opacity-50"
                                            onClick={() => { handleAccountNavigation('surveys'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-clipboard-data me-2'></i>الاستبيانات
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item opacity-50"
                                            onClick={() => { handleAccountNavigation('podcasts'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-mic me-2'></i>بودكاست
                                        </button>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => { handleAccountNavigation('support'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-chat-text me-2'></i>الطلبات والدعم
                                        </button>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => { handleAccountNavigation('accountSettings'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-gear me-2'></i>إعدادات الحساب
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => { handleAccountNavigation('security'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-lock me-2'></i>الأمان وكلمة المرور
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item opacity-50"
                                            onClick={() => { handleAccountNavigation('googleLink'); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-google me-2'></i>ربط حساب Google
                                        </button>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li> */}
                                    <li>
                                        <button
                                            className="dropdown-item text-danger"
                                            onClick={() => { handleLogout(); closeMenu(); removeBlur(); }}
                                        >
                                            <i className='bi bi-box-arrow-left me-2'></i>تسجيل الخروج
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>) : (<div className="ms-md-auto ms-xl-5 align-items-center mt-y my-md-0 d-inline-flex d-md-none">

                            <button
                                className="btn btn-outline-dark rounded-3 d-md-block d-none me-1 py-1 px-2 w-auto"
                                aria-label="البحث"
                                onClick={openSearchModal}
                                title="البحث"
                            >
                                <i className="bi bi-search fs-5 text-dark"></i>
                            </button>
                            {/* <button
                                className="btn btn-outline-dark rounded-3 d-md-none me-1 py-1 px-2 w-auto fs-5"
                                aria-label={isDark ? 'Light mode' : 'Dark mode'}
                                onClick={toggleTheme}
                            >
                                <i className={`bi ${isDark ? 'bi-sun' : 'bi-moon'} fs-5 text-dark`}></i>
                            </button> */}

                            <Link href="/login" className='btn rounded-3 pt-2' onClick={closeMenu}><i className='bi bi-person-circle fs-1 lh-1'></i></Link>
                        </div>)}

                    <div className="collapse navbar-collapse row mx-0 ms-auto" id="navbarNavAltMarkup">
                       


                        <div className="navbar-nav justify-content-start justify-content-md-center">
                            <div className="row d-block d-lg-flex mx-0 justify-content-between">

                          {/* Search Icon Button - Mobile */}
                        <div className="d-md-none w-100 mb-3 px-0">
                            <button
                                className="btn btn-outline-dark rounded-3 w-100"
                                aria-label="البحث"
                                onClick={openSearchModal}
                            >
                                <i className="bi bi-search me-2"></i>
                                ابحث...
                            </button>
                        </div>   
                            <hr className='d-md-none' />
                                {navItems.map((item) => (
                                    <Link
                                        key={item.href}
                                        href={item.href}
                                        target={item.new ? 'new' : ''}
                                        className={`${pathname === item.href ? 'nav-link-active text-dark fw-bold' : ''}  nav-link col-auto p-1 py-xl-2 px-xl-2 position-relative`}
                                        onClick={closeMenu}
                                    >
                                        {item.icon && (<i className={`${item.icon} me-1`}></i>)}
                                        {item.img && (<Image src={chatGTP} alt='ChatGTP Zaki Figmawya' width={24} height={24} className='mb-2 me-1' />)}
                                        {item.label}
                                        {item.showNotification && <NotificationDot count={todayJobsCount} />}
                                    </Link>
                                ))}
                                 
                                 <hr className='d-md-none' />
                                    <button
                                className="d-md-none btn btn-outline-dark rounded-3 d-md-none me-1 py-1 px-2 w-100 fs-5"
                                aria-label={isDark ? 'Light mode' : 'Dark mode'}
                                onClick={toggleTheme}
                            >
                                <i className={`bi ${isDark ? 'bi-sun' : 'bi-moon'} fs-5 text-dark me-2 `}></i>
                                 {isDark ? 'النمط النهاري' : 'النمط الليلي'}
                            </button>
                            </div>
                        </div>
                    </div>

                    {authi === true ? (

                        <div className="col-md-2 me-0 justifiy-content-end align-items-end my-4 my-md-0 d-none d-md-flex">
                            <button
                                className="btn btn-outline-dark rounded-3 d-md-block d-none me-1 py-1 px-2 w-auto"
                                aria-label="البحث"
                                onClick={openSearchModal}
                                title="البحث"
                            >
                                <i className="bi bi-search fs-5 text-dark"></i>
                            </button>
                            <button
                                className='d-none d-md-block btn btn-outline-dark rounded-3 me-1 ms-1 col-auto text-dark  fs-5 py-1 px-2'
                                aria-label={isDark ? 'Light mode' : 'Dark mode'}
                                onClick={toggleTheme}
                            >
                                <i className={`bi ${isDark ? 'bi-sun' : 'bi-moon'}`}></i>
                            </button>

                            {/* Temporary test button for notifications - desktop */}
                            {/* <button 
                                    className='btn btn-outline-danger rounded-3 me-2 col-auto'
                                    onClick={() => setTodayJobsCount(prev => prev + 1)}
                                    title="Test notification"
                                >
                                    <i className="bi bi-bell"></i>
                                </button> */}
                            <Link href="/account" className='btn btn-outline-dark mb-2 mb-md-0 me-2 ms-1 col-12 px-1 col-md-auto rounded-3' onClick={closeMenu}>  {user && user.avatar ? (<Image src={user.avatar} className='rounded-circle' width={24} height={24} />) : <i className='bi bi-person-circle'></i>} {user?.user_display_name ? truncateText(user.user_display_name, 8) : 'حسابي'}  </Link>
                            {/* <button className='btn btn-danger col-12 col-md-auto rounded-3' onClick={() => { handleLogout(); closeMenu(); }}> <i className="bi bi-arrow-left-square"></i></button> */}
                        </div>
                    ) : (
                        <div className="row me-0 ms-0 ms-md-4 ms-xl-5 align-items-center mt-y my-md-0  d-none d-md-flex">
                            <button
                                className="btn btn-outline-dark rounded-3 d-md-block d-none me-1 py-1 px-2 w-auto"
                                aria-label="البحث"
                                onClick={openSearchModal}
                                title="البحث"
                            >
                                <i className="bi bi-search fs-5 text-dark"></i>
                            </button>
                            <button
                                className='d-none d-md-block btn btn-outline-dark rounded-3 ms-0 ms-md-2 col-auto fs-5 py-1 px-2'
                                aria-label={isDark ? 'Light mode' : 'Dark mode'}
                                onClick={toggleTheme}
                            >
                                <i className={`bi ${isDark ? 'bi-moon' : 'bi-sun'}`}></i>
                            </button>

                            {/* Temporary test button for notifications - non-auth desktop */}
                            {/* <button 
                                    className='btn btn-outline-danger rounded-3 ms-0 ms-md-2 col-auto'
                                    onClick={() => setTodayJobsCount(prev => prev + 1)}
                                    title="Test notification"
                                >
                                    <i className="bi bi-bell"></i>
                                </button> */}
                            <Link href="/login" className='btn btn-outline-dark rounded-3 ms-0 ms-md-2 col-12 col-md-auto mb-2 mb-md-0' onClick={closeMenu}>تسجيل الدخول</Link>
                            <Link href="/signup" className='btn btn-dark rounded-3 ms-0 ms-md-2 col-12 col-md-auto' onClick={closeMenu}>إنضم لنا</Link></div>)}


                </div>
                {/* <div class="progress-container">
                <div class="progress"></div>
            </div> */}
            </nav>

            {/* Breadcrumbs */}
            <BreadcrumbsNav pathname={pathname} />

            {/* Search Modal */}
            <div className={`modal fade ${showSearchModal ? 'show' : ''}`}
                style={{ display: showSearchModal ? 'block' : 'none' }}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="searchModalLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <h5 className="modal-title" id="searchModalLabel">
                                <i className="bi bi-search me-2"></i>البحث
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={closeSearchModal}
                                aria-label="إغلاق"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSearch}>
                                <div className="position-relative">
                                    <input
                                        ref={searchInputRef}
                                        type="text"
                                        className="form-control form-control-lg rounded-pill ps-4 pe-5"
                                        placeholder="ابحث عن..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        onKeyPress={handleSearchKeyPress}
                                        style={{ paddingRight: '3rem' }}
                                    />
                                    <i className="bi bi-search position-absolute end-0 top-50 translate-middle-y me-3 text-muted" style={{ pointerEvents: 'none' }}></i>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer border-0 justify-content-between">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={closeSearchModal}
                            >
                                <i className="bi bi-x-circle me-2"></i>إلغاء
                            </button>
                            <button
                                type="button"
                                className="btn btn-dark"
                                onClick={handleSearch}
                                disabled={!searchQuery.trim()}
                            >
                                <i className="bi bi-search me-2"></i>بحث
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Backdrop */}
            {showSearchModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
}

// // Breadcrumbs component integrated into Navbar
// function BreadcrumbsNav({ pathname }) {
//     // Route mapping for Arabic labels
//     const routeLabels = {
//         '/': 'الرئيسية',
//         '/sections': 'الأقسام',
//         '/sections/articles': 'المقالات',
//         '/sections/podcasts': 'البودكاست',
//         '/sections/challenges': 'التحديات',
//         '/sections/templates': 'القوالب',
//         '/sections/plugins': 'الإضافات',
//         '/sections/jobs': 'الوظائف',
//         '/sections/shorts': 'الشورتات',
//         '/sessions': 'الجلسات',
//         '/services': 'الخدمات',
//         '/services/courses': 'الدورات التعليمية',
//         '/services/glossary': 'القاموس',
//         '/services/calc': 'تسعير',
//         '/services/design-reviews': 'مراجعات التصميم',
//         '/account': 'الحساب',
//         '/lnk': 'إختصار الروابط',
//     };

//     // Generate breadcrumbs from pathname
//     const breadcrumbs = useMemo(() => {
//         // Don't show breadcrumbs on home page
//         if (pathname === '/') {
//             return null;
//         }

//         // Split pathname into segments
//         const segments = pathname.split('/').filter(Boolean);
//         const crumbs = [];

//         // Always add home
//         crumbs.push({
//             label: routeLabels['/'] || 'الرئيسية',
//             href: '/',
//         });

//         // Build path progressively
//         let currentPath = '';
//         segments.forEach((segment, index) => {
//             currentPath += `/${segment}`;
//             const isLast = index === segments.length - 1;

//             // Get label from routeLabels or use segment
//             const label = routeLabels[currentPath] || 
//                          segment.split('-').map(word => 
//                              word.charAt(0).toUpperCase() + word.slice(1)
//                          ).join(' ');

//             crumbs.push({
//                 label: label,
//                 href: isLast ? null : currentPath, // Last item is not a link
//             });
//         });

//         return crumbs;
//     }, [pathname]);

//     // Don't show breadcrumbs on home page
//     if (!breadcrumbs || pathname === '/') {
//         return null;
//     }

//     return (
//         <nav aria-label="breadcrumb" className="breadcrumb-nav container mx-auto">
//             <div className="container">
//                 <ol className="breadcrumb mb-0 py-2">
//                     {breadcrumbs.map((crumb, index) => {
//                         const isLast = index === breadcrumbs.length - 1;
//                         return (
//                             <li
//                                 key={crumb.href || index}
//                                 className={`breadcrumb-item ${isLast ? 'active' : ''}`}
//                                 aria-current={isLast ? 'page' : undefined}
//                             >
//                                 {isLast ? (
//                                     <span className="text-truncate d-inline-block" style={{ maxWidth: '300px' }}>
//                                         {crumb.label}
//                                     </span>
//                                 ) : (
//                                     <Link href={crumb.href} className="text-decoration-none text-muted">
//                                         {crumb.label}
//                                     </Link>
//                                 )}
//                             </li>
//                         );
//                     })}
//                 </ol>
//             </div>
//         </nav>
//     );
// }